import { Button, Spinner } from '@bennows/boows-react';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Navigate, useLocation } from 'react-router-dom';
import { useOperatorMe, type OperatorMe } from '../auth/useOperatorMe';

/**
 * Only a verified operator session reaches the console (REQ-140-004); the
 * server enforces it, this gate only routes. Without one: the sign-in page.
 */
export function ConsoleGate({ children }: { readonly children: (me: OperatorMe) => ReactNode }) {
  const { t } = useTranslation();
  const location = useLocation();
  const me = useOperatorMe();
  if (me.isPending) {
    return (
      <main id="main" className="ui-console-loading" tabIndex={-1}>
        <Spinner label={t('shell.loading')} showLabel />
      </main>
    );
  }
  if (me.isError) {
    return (
      <main id="main" className="ui-console-loading" tabIndex={-1}>
        <div className="ui-error-state" role="alert">
          <p className="ui-error-state__text">{t('common.errorNetwork')}</p>
          <Button variant="secondary" onClick={() => void me.refetch()}>
            {t('common.retry')}
          </Button>
        </div>
      </main>
    );
  }
  if (!me.data?.verified) {
    const returnTo = `${location.pathname}${location.search}`;
    return <Navigate to={returnTo === '/' ? '/sign-in' : `/sign-in?return_to=${encodeURIComponent(returnTo)}`} replace />;
  }
  return <>{children(me.data)}</>;
}
